module.exports = __webpack_public_path__ + "9c1b4e245e0e908e4dcae4ecff18d386.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2024-12-12/whats-new.html
// module id = 2332
// module chunks = 0